import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import SiteGraphReportComponent from '../../components/SiteGraphReportComponent/SiteGraphReportComponent'

const SiteGraphReport = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <SiteGraphReportComponent/>
                </div>
            </div>
        </div>
    )
}

export default SiteGraphReport
